import React, { useState, useEffect, useCallback } from 'react';
import axios from "axios";
import { MutatingDots } from "react-loader-spinner";
import "./DateTimePicker.css";
import { connect } from "react-redux";
import moment from 'moment-timezone';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    FormGroup,
    IconButton,
    Menu,
    MenuItem,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
    Typography
} from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticTimePicker } from '@mui/x-date-pickers/StaticTimePicker';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { AutoDelete, History, Schedule } from "@mui/icons-material";
import {
    addScheduleThunk,
    deleteScheduleThunk,
    getAllSurveysWithScheduleThunk,
    getAllUserSurveysThunk
} from "../../../../redux/survey/survey.thunk";
import { getUserThunk } from "../../../../redux/users/users.thunk";
import { palette } from "../../../../assets/styles/theme";
// import { Navigate } from "react-router-dom";

const rotateToMondayFirst = (arr) => [...arr.slice(1), arr[0]];
const rotateToSundayFirst = (arr) => [arr[arr.length - 1], ...arr.slice(0, arr.length - 1)];

const SlackDateTimePicker = (props) => {
    /* ──────────────────────────────── PROPS ─────────────────────────────── */
    const {
        // redux / navigation
        surveyId,
        tenantId,
        scheduleId,
        // optional pre‑selected schedule fields
        days: propDays,
        hours: propHours,
        minutes: propMinutes,
        // callbacks
        addScheduleSlack,
        deleteScheduleSlack,
        getAllSurveysWithScheduleSlack,
        getUserSlack,
        getAllUserSurveys,
        // misc/ui
        children,
        className,
        user,
    } = props;

    /* ──────────────────────────────── STATE ─────────────────────────────── */
    const [isOpen, setIsOpen]               = useState(false);
    const [openMenu, setOpenMenu]           = useState(null);
    const [type, setType]                   = useState(scheduleId ? 'EDIT' : 'SCHEDULE');
    const [days, setDays]                   = useState([false,false,false,false,false,false,false]);
    const [myDays, setMyDays]               = useState([]);                   // string array of selected indexes
    const [time, setTime]                   = useState("09:00");
    const [dateTime, setDateTime]           = useState(() => {
        const d = new Date();
        d.setHours(9,0,0);
        return d;
    });
    const [sending, setSending]             = useState(false);
    const [success, setSuccess]             = useState(false);
    const [message, setMessage]             = useState('');
    const [hasDay, setHasDay]               = useState(false);
    const [hasSubmit, setHasSubmit]         = useState(false);
    // const [redirect, setRedirect]           = useState(false);

    /* ───────────────────────── derive `type` from `scheduleId` ──────────── */
    useEffect(() => {
        setType(scheduleId ? 'EDIT' : 'SCHEDULE');
    }, [scheduleId]);

    /* ─────────────────────────────── HELPERS ────────────────────────────── */
    const openDialog = useCallback(() => {
        setSuccess(false);
        setMessage("");
        setIsOpen(true);
        console.log("p**** ropDays raw from API:", propDays);
        /* populate schedule data when opening */
        // if (propDays) {
        //     const newMyDays = propDays.reduce((acc, flag, idx) => {
        //         if (flag) acc.push(idx.toString());
        //         return acc;
        //     }, []);
        //     setDays(propDays);
        //     setMyDays(newMyDays);
        //     setHasDay(newMyDays.length>0);
        // }
            /* populate schedule data when opening */
            console.log("step 1")
        if (propDays) {
            const daysMonFirst = rotateToMondayFirst(propDays);
            setDays(daysMonFirst);
            const newMyDays = daysMonFirst
            .map((flag, idx) => (flag ? idx.toString() : null))
            .filter((v) => v !== null);
            setMyDays(newMyDays);
            setHasDay(newMyDays.length > 0);
        }
        console.log("step 2")
        // if (typeof propHours === 'number' && typeof propMinutes === 'number') {
        //     const hh   = propHours.toString().padStart(2,'0');
        //     const mm   = propMinutes.toString().padStart(2,'0');
        //     const tStr = `${hh}:${mm}`;
        //     const d    = new Date();
        //     d.setHours(propHours, propMinutes, 0);
        //     setTime(tStr);
        //     setDateTime(d);
        // }
        console.log("propHours:", propHours, "propMinutes:", propMinutes);
        // **NEW: convert UTC DB time to local for display**
        if (typeof propHours === "number" && typeof propMinutes === "number") {
            // build a moment in UTC on *today’s* date but with your DB hours/minutes
            const utcMoment = moment
            .utc()
            .hour(propHours)
            .minute(propMinutes)
            .second(0);

            // convert that instant into the user’s local zone
            const localMoment = utcMoment.local();

            // show it in the picker
            setDateTime(localMoment.toDate());
            setTime(localMoment.format("HH:mm"));
        } else {
            // fallback to “now”
            const now = moment();
            setDateTime(now.toDate());
            setTime(now.format("HH:mm"));
        }
    }, [propDays, propHours, propMinutes]);

    const closeDialog = () => {
        setIsOpen(false);
        setSuccess(false);
    };

    // const handleDayChange = (e/*: React.ChangeEvent<HTMLInputElement>*/) => {
    //     const idx = Number(e.target.name);
    //     setDays(prev => {
    //         const nxt = [...prev];
    //         nxt[idx] = !prev[idx];
    //         /* recalc hasDay */
    //         setHasDay(nxt.some(Boolean));
    //         return nxt;
    //     });
    // };

    const handleDaysGroup = (_e, newMyDays /* string[] */) => {
        setMyDays(newMyDays);
        /* convert to boolean[7] */
        const newFlags = [false,false,false,false,false,false,false];
        newMyDays.forEach(i=>{ newFlags[Number(i)] = true; });
        setDays(newFlags);
        setHasDay(newMyDays.length>0);
    };

    const handleTimeChange = (value /* Date|string|number */) => {
        const d = new Date(value);
        setDateTime(d);
        setTime(moment(d).format('HH:mm'));
    };

    /* ───────────────────────────────── SUBMIT ───────────────────────────── */
    const handleSubmit = async () => {
        console.log("SUBMIT");
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setHasSubmit(true);

        if (!hasDay) return; // prevent submit without day

        // delete existing instance when editing
        if (type === 'EDIT') {
            await handleDelete(scheduleId, 'edits');
        }

        const local  = moment.tz(dateTime, tz);
        const utc    = local.clone().utc();
        const hours  = utc.format('HH');
        const minutes= utc.format('mm');
        const new_days = rotateToSundayFirst(days)
        console.log("new_days:", new_days);
        const obj = {
            days: new_days,
            hours,
            minutes,
            tenantId,
            surveyId,
            state: true,
        };
        console.log(obj);

        setSending(true);

        try {
            const res = await axios.post(
                "https://survey-schedule-new.azurewebsites.net/api/orchestrators/NewSchedule",
                obj
            );

            if (res.status === 202) {
                obj.id    = res.data.id;
                obj.userId= user?.id || null;

                await addScheduleSlack(obj);
                if (type === "EDIT") {
                    props.setSnackbarMsg("All set! Your schedule has been updated.");
                } else {
                    props.setSnackbarMsg("Scheduled successfully!");
                }
                props.setOpenSnackbar(true);
                // props.setOpen(true);  
                getAllUserSurveys(user.id);
                setIsOpen(false);     
                // setMessage("Successfully scheduled");
                // setSuccess(true);
                // setRedirect(true);
            }
        } catch(err) {
            console.error('Error scheduling:', err);
            setMessage(err?.message || 'Unknown error');
            setSuccess(true);
        } finally {
            setSending(false);
            getAllUserSurveys(user.id);
        }
    };

    /* ───────────────────────────────── DELETE ───────────────────────────── */
    // const handleDelete = async (id, reason) => {
    //     setSending(true);
    //     try {
    //         const res = await axios.post(
    //             `https://survey-schedule-new.azurewebsites.net/runtime/webhooks/durabletask/instances/${id}/terminate?reason=${reason}&taskHub=surveyschedulenew&connection=Storage&code=ITF661b72qJzHRV0oEtVK2P7WhuVEnKxXgDiF30alaxQAQZ2SdFVyA==`
    //         );
    //         if (res.status === 202) {
    //             console.log("Deleted an instance from Azure");
    //             await deleteScheduleSlack(id);
    //             props.setSnackbarMsg("All set! Your schedule has been deleted.");
    //             props.setOpenSnackbar(true);
    //             setMessage("Successfully deleted");
    //             setSuccess(true);
    //             if (reason !== 'edits') {
    //                 getAllUserSurveys(user.id);
    //                 // setRedirect(true);
    //             }
    //         }
    //     } catch (err) {
    //         console.error('Error deleting schedule:', err);
    //         setMessage(err?.message || 'Unknown error');
    //         setSuccess(true);
    //     } finally {
    //         setSending(false);
    //     }
    // };
    const handleDelete = async (id, reason) => {
        setSending(true);
        try {
          const response = await axios.post(
            `https://survey-schedule-new.azurewebsites.net/runtime/webhooks/durabletask/instances/${id}/terminate` +
            `?reason=${reason}&taskHub=surveyschedulenew&connection=Storage` +
            `&code=ITF661b72qJzHRV0oEtVK2P7WhuVEnKxXgDiF30alaxQAQZ2SdFVyA==`
          );
      
          if (response.status === 202) {
            console.log("Successfully terminated the Azure instance");
            await deleteScheduleSlack(id);
      
            // 1) Notify parent via Snackbar
            props.setSnackbarMsg("All set! Your schedule has been deleted.");
            props.setOpenSnackbar(true);
      
            // 2) Close this dialog
            setIsOpen(false);
      
            // 3) Refresh surveys list if this wasn’t just part of an edit flow
            if (reason !== 'edits') {
              getAllUserSurveys(user.id);
            }
          }
        } catch (error) {
          console.error("Error deleting schedule:", error);
      
          // Optionally show error in parent Snackbar
          props.setSnackbarMsg(error?.message || "Unknown error occurred");
          props.setOpenSnackbar(true);
        } finally {
          setSending(false);
        }
      };
      
    /* ───────────────────────────── MENU HANDLERS ────────────────────────── */
    const openMenuHandler  = (e) => setOpenMenu(e.currentTarget);
    const closeMenuHandler = () => setOpenMenu(null);

    /* ──────────────────────────────── RENDER ────────────────────────────── */
    // if (redirect) {
    //     console.log("*** redirecting to home");
    //     return <Navigate to="/" replace />;
    // }

    if (sending) {
        return (
            <div style={{
                position:'fixed', inset:0,
                display:'flex', alignItems:'center', justifyContent:'center',
                background:'rgba(255,255,255,0.8)', zIndex:9999
            }}>
                <MutatingDots height="100" width="100" color={palette.primary} visible />
            </div>
        );
    }

    return (
        <div className={children ? 'w-100' : ''}>
            <Tooltip title="Schedule">
                {type === 'SCHEDULE' ? (
                    children ? (
                        <Button onClick={openDialog} className={className}>{children}</Button>
                    ) : (
                        <IconButton onClick={openDialog}><Schedule/></IconButton>
                    )
                ) : (
                    children ? (
                        <Button onClick={openMenuHandler} className={className}>{children}</Button>
                    ) : (
                        <IconButton onClick={openMenuHandler}><Schedule/></IconButton>
                    )
                )}
            </Tooltip>

            {type === 'EDIT' && (
                <Menu
                    anchorEl={openMenu}
                    open={Boolean(openMenu)}
                    onClose={closeMenuHandler}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top',    horizontal: 'right' }}
                    >
                    <MenuItem onClick={() => { 
                        closeMenuHandler(); 
                        openDialog(); 
                    }}>
                        <History fontSize="small" /> Edit
                    </MenuItem>
                    <MenuItem onClick={() => { 
                        closeMenuHandler(); 
                        handleDelete(scheduleId, 'user canceled by clicking a button'); 
                    }}>
                        <AutoDelete fontSize="small" /> Delete
                    </MenuItem>
                </Menu>


            )}

<Dialog open={isOpen} onClose={closeDialog}>
  <DialogContent>
    <p className="text-black-50">SELECT DAYS</p>
    <FormGroup>
      <ToggleButtonGroup
        value={myDays}
        onChange={handleDaysGroup}
        color="primary"
        className="justify-content-center"
        aria-label="myDays"
      >
        {['Mon','Tue','Wed','Thur','Fri','Sat','Sun'].map((label,idx) => (
          <ToggleButton
            key={idx}
            value={idx.toString()}
            aria-label={label.toLowerCase()}
            sx={{ fontSize: { xs:'0.6rem', md:'1rem' } }}
          >
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {!hasDay && hasSubmit && (
        <div className="text-danger text-center fs-6">
          <small>You need to select at least one day</small>
        </div>
      )}
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <StaticTimePicker
          displayStaticWrapperAs="mobile"
          value={dateTime}
          onChange={handleTimeChange}
          renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
    </FormGroup>
  </DialogContent>

  <DialogActions>
    <div className="d-flex justify-content-center">
      <MutatingDots
        color={palette.primary}
        height="100"
        width="100"
        visible={sending}
      />
    </div>
    <div className="text-end w-100">
      <Button onClick={closeDialog} color="primary">Cancel</Button>
      <Button variant="contained" onClick={handleSubmit} color="primary">
        Ok
      </Button>
    </div>
  </DialogActions>
</Dialog>

        </div>
    );
};

/* ─────────────────────────── REDUX CONNECTION ─────────────────────────── */
const mapStateToProps = (state) => ({
    user: state.users.user,
});

const mapDispatchToProps = (dispatch) => ({
    addScheduleSlack:             (obj)  => dispatch(addScheduleThunk(obj)),
    deleteScheduleSlack:          (id)   => dispatch(deleteScheduleThunk(id)),
    getAllSurveysWithScheduleSlack:(id)  => dispatch(getAllSurveysWithScheduleThunk(id)),
    getUserSlack:                 (email)=> dispatch(getUserThunk(email)),
    getAllUserSurveys:            (uid)  => dispatch(getAllUserSurveysThunk(uid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SlackDateTimePicker);
